export default theme => ({
  layout: {
    padding: '12vh 24px 24px',
    '& [class*="fadeTransition"]': {
      height: 'auto',
      alignItems: 'center'
    }
  },
  logo: {
    marginBottom: 40,
    width: 141,
    '& > *': {
      width: '100%'
    }
  },
  stepper: {
    width: '100%',
    maxWidth: 560,
    marginBottom: 48
  },
  nav: {
    display: 'grid',
    gridAutoColumns: 'minmax(0, 1fr)',
    gridAutoFlow: 'column',
    marginTop: 24,
    gridGap: 24
  }
});